const makeConstant = constant => `ban/${constant}`

export const GET_API_KEY_FOR_ORG = makeConstant('GET_API_KEY_FOR_ORG')
export const GET_API_KEY_FOR_ORG_SUCCESS = makeConstant('GET_API_KEY_FOR_ORG_SUCCESS')
export const GET_API_KEY_FOR_ORG_FAILED = makeConstant('GET_API_KEY_FOR_ORG_FAILED')
export const GET_API_KEY_FOR_ORG_PENDING = makeConstant('GET_API_KEY_FOR_ORG_PENDING')

export const CREATE_API_KEY_FOR_ORG = makeConstant('CREATE_API_KEY_FOR_ORG')
export const CREATE_API_KEY_FOR_ORG_SUCCESS = makeConstant('CREATE_API_KEY_FOR_ORG_SUCCESS')
export const CREATE_API_KEY_FOR_ORG_FAILED = makeConstant('CREATE_API_KEY_FOR_ORG_FAILED')
export const CREATE_API_KEY_FOR_ORG_PENDING = makeConstant('CREATE_API_KEY_FOR_ORG_PENDING')


// WEBPACK FOOTER //
// ./src/modules/apiKey/constants.js